<app-topnav [llttfPage]="true" [pageName]="pageName"></app-topnav>
<div class="container">
  <div class="content user-mgmt-page" role="main">
    <header class="user-mgmt-page__header">
      <div>
        <h1 class="user-mgmt-page__title">Org Management</h1>
        <p class="user-mgmt-page__subtitle">Search, filter, and manage organizations across provinces.</p>
        @if (totalRecords > 0) {
          <div class="user-mgmt-page__meta">
            <span class="user-mgmt-page__count">{{ totalRecords | number }} organizations found</span>
          </div>
        }
      </div>
      <div class="user-mgmt-page__actions">
        <a routerLink="/add-org" class="user-mgmt-page__btn user-mgmt-page__btn--primary">
          <mat-icon>add</mat-icon>
          Add Organization
        </a>
      </div>
    </header>

    <section class="user-mgmt-page__filters">
      <form (ngSubmit)="search()">
        <div class="user-mgmt-page__filters-grid">
          <mat-form-field appearance="outline" floatLabel="always">
            <mat-label>Search</mat-label>
            <mat-icon matPrefix>search</mat-icon>
            <input matInput class="form-control-textbox" name="filterSearch" [(ngModel)]="queryFilter.OrgKeyword" placeholder="Organization name" />
          </mat-form-field>

          <mat-form-field appearance="outline" floatLabel="always">
            <mat-label>Province</mat-label>
            <mat-select placeholder="All Provinces" name="filterprovince" [(ngModel)]="queryFilter.ProvinceId">
              <mat-option value="0">All Provinces</mat-option>
              @for (p of provinces; track p) {
                <mat-option [value]="p.id">{{ p.provinceName }}</mat-option>
              }
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" floatLabel="always">
            <mat-label>Status</mat-label>
            <mat-select placeholder="All Statuses" name="filterStatus" [(ngModel)]="queryFilter.Status">
              <mat-option value="">All Statuses</mat-option>
              <mat-option value="ACTIVE">Active</mat-option>
              <mat-option value="INACTIVE">Inactive</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="user-mgmt-page__filters-actions">
          <button class="user-mgmt-page__btn user-mgmt-page__btn--primary" type="submit" #submitButton>
            <mat-icon>filter_list</mat-icon>
            Apply Filters
          </button>
          <button class="user-mgmt-page__btn user-mgmt-page__btn--secondary" type="button" (click)="resetFilters()">
            <mat-icon>restart_alt</mat-icon>
            Reset
          </button>
        </div>
      </form>
    </section>

    <section class="user-mgmt-page__table-card">
      <ng-container *ngTemplateOutlet="table; context: { data: orgList, headerVisible: true }"></ng-container>
      <mat-paginator
        #paginator
        [length]="totalRecords"
        [pageSize]="25"
        [hidden]="totalRecords === 0"
        [pageSizeOptions]="[10, 25, 50]"
        (page)="handlePageEvent($event)"
        aria-label="Organization list pagination">
      </mat-paginator>
    </section>
  </div>
</div>

<ng-template #table let-data="data" let-headerVisible="headerVisible">
  <app-no-results #noResults></app-no-results>

  <table mat-table class="fileList primary" [dataSource]="data" [hidden]="data.length === 0">
    <ng-container matColumnDef="orgname">
      <th mat-header-cell *matHeaderCellDef>Organization Name</th>
      <td mat-cell *matCellDef="let orgs">
        <a [routerLink]="['/view-org', orgs.id]" class="user-mgmt-page__user-link">{{ orgs.organizationName }}</a>
      </td>
    </ng-container>

    <ng-container matColumnDef="province">
      <th mat-header-cell *matHeaderCellDef>Province</th>
      <td mat-cell *matCellDef="let orgs">{{ orgs.province }}</td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef>
        Status
        <app-information-popup [information]="information"></app-information-popup>
      </th>
      <td mat-cell *matCellDef="let orgs">
        <app-status-bubble [status]="orgs.status"></app-status-bubble>
      </td>
    </ng-container>

    @if (headerVisible) {
      <tr mat-header-row *matHeaderRowDef="columnsToDisplay" class="tableHeader"></tr>
    }
    <tr mat-row *matRowDef="let row; columns: columnsToDisplay"></tr>
  </table>
</ng-template>

<app-footer></app-footer>
